module.exports = __webpack_public_path__ + "static/media/veritcal_icon_tree.25be5e62.svg";